module.exports = __webpack_public_path__ + "why7.webp?1d70549be27c5640877d8a2986478d71";